import { normalizeFullSlug } from '@/helpers/slug';
import { detectLocale } from '@/helpers/storyblok';

import { LOCALES } from '@/config';

/**
 * @typedef {Object} StoryLanguage
 * @property {import('@/config').Locale} locale
 * @property {string} href
 * @property {boolean} current
 */

/**
 * @param {string} fullSlug
 * @returns {import('@/config').Locale | undefined}
 */
const findLocale = (fullSlug) => {
  const prefix = fullSlug?.split?.('/')?.[0];

  return LOCALES.find((locale) => locale.shortCode === prefix);
};

/**
 * @param {object} story
 * @returns {StoryLanguage[]}
 */
export const getStoryLanguages = (story) => {
  if (!story?.full_slug || !(story.alternates?.length > 0)) {
    return [];
  }

  const currentLocale = detectLocale(story.full_slug.split('/'));

  const alternates = story.alternates
    .filter((alternate) => alternate.published)
    .map((alternate) => ({
      locale: findLocale(alternate.full_slug),
      href: normalizeFullSlug(alternate.full_slug),
      current: false,
    }))
    .filter(
      (alternate) =>
        alternate.locale &&
        alternate.locale.shortCode !== currentLocale.shortCode,
    );

  if (alternates.length === 0) {
    return [];
  }

  return [
    {
      locale: currentLocale,
      href: normalizeFullSlug(story.full_slug),
      current: true,
    },
    ...alternates,
  ].sort((a, b) => LOCALES.indexOf(a.locale) - LOCALES.indexOf(b.locale));
};

export const LANGUAGES_TITLE = {
  fr: 'Langues',
  en: 'Languages',
  es: 'Idiomas',
  'pt-br': 'Idiomas',
};
